module.exports = __webpack_public_path__ + "static/media/icon-user.b3b1a9b3.svg";